import React from 'react';
import corporateSettings from 'utils/corporateSettings.json';

const SPLITRISK_SAC = '0800 718 0135';

const OMBUDSMAN_CHANNELS = [
  { label: 'Ouvidoria', value: '0800 703 1989 ou ouvidoria@sinapp.org.br' },
  { label: 'Ouvidoria Deficiente Visual', value: '0800 703 1989 ou ouvidoria.visual@sinapp.org.br' },
  {
    label: 'Ouvidoria Deficiente Fala ou Auditivo',
    value: '0800 201 1838 (somente através de telefone fixo TDD) ou ouvidoria.auditivo.fala@sinapp.org.br',
  },
];

function DocumentSupportChannels({ partner }) {
  const partnerSettings = corporateSettings.find(({ id_partner }) => Number(id_partner) === Number(partner?.id));
  const additionalChannels = partnerSettings?.document_support_channels || [];

  return (
    <>
      <b>Canais de Atendimento</b>
      <h4>SAC MGA: {partner?.phone_sac}</h4>
      <h4>SAC Split Risk: {SPLITRISK_SAC}</h4>
      <h4>Assistência 24h: {partner?.phone_support}</h4>
      {!partnerSettings?.hide_email_on_documents && <h4>Email: {partner?.email}</h4>}
      {additionalChannels.map(({ label, value, href }) => (
        <h4 key={label}>
          {label}:{' '}
          {href ? (
            <a href={href} target="_blank" rel="noreferrer">
              {value}
            </a>
          ) : (
            value
          )}
        </h4>
      ))}
      {OMBUDSMAN_CHANNELS.map(({ label, value }) => (
        <h4 key={label}>
          {label}: {value}
        </h4>
      ))}
    </>
  );
}

export default DocumentSupportChannels;
